<template>
        <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-5">
          <div class="col">
            <div class="comon-footer-mns d-inline-block w-100">
              <a href="/login" class="foot-logo">
                <img src="static/static/picture/logo.png" alt="logo">
              </a>
              <p class="fo-text mt-5 col-lg-11"> 专注在企业信息化领域，致力于企业信息技术应用一体化方案、关于我们及服务的研究。</p>
            </div>
          </div>

          <div class="col">
            <div class="comon-footer-mns d-inline-block w-100">
              <h5>快速链接</h5>
              <ul class="main-links mt-5">
                <li class="d-flex align-items-center">
                  <router-link to="/about">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-arrow-right-short" viewbox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                        </path>
                      </svg>
                    </span>
                    关于我们
                  </router-link>
                </li>
                <li>
                  <router-link to="/feature">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-arrow-right-short" viewbox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                        </path>
                      </svg>
                    </span>
                    特色
                  </router-link>
                </li>
                <li>
                  <router-link to="/price">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-arrow-right-short" viewbox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                        </path>
                      </svg>
                    </span>
                    价格
                  </router-link>
                </li>
                <li>
                  <router-link to="/contact">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-arrow-right-short" viewbox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                        </path>
                      </svg>
                    </span>
                    联系我们
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

          <div class="col">
            <div class="comon-footer-mns d-inline-block w-100">
              <h5> 用户案例 </h5>
              <ul class="main-links mt-5">
                <li class="d-flex align-items-center">
                  <router-link to="/case">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-arrow-right-short" viewbox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                        </path>
                      </svg>
                    </span>
                    客服助手
                  </router-link>
                </li>
                <li>
                  <router-link to="/case">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-arrow-right-short" viewbox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                        </path>
                      </svg>
                    </span>
                  AI 绘画
                  </router-link>
                </li>
                <li>
                  <router-link to="/case">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-arrow-right-short" viewbox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                        </path>
                      </svg>
                    </span>
                    写作助手
                  </router-link>
                </li>
                <li>
                  <router-link to="/case">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-arrow-right-short" viewbox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z">
                        </path>
                      </svg>
                    </span>
                    星座运势
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col">
            <div class="comon-footer-mns d-inline-block w-100">
              <h5> 联系我们 </h5>

              <div class="foter-subcribe-div d-inline-block w-100 mt-5">
            
                <p>电话：4008339068</p>
                <p> 邮箱：admin@jero168.com</p>
                <p> QQ：4008339068</p>
                <p>地址：重庆市北部新区土星C3座22-3</p>
 
              </div>
            </div>
          </div>
        </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style scoped lang="less"></style>
